import { ePlantTreeTagClusterConfigs } from "./ePlant/ePlantTreeTagClusterConfigs.js";
import { badgermeterFlowmeterClusterConfigs } from "./flowmeters/badgermeterFlowmeterClusterConfigs.js";
import { flomecFlowmeterClusterConfigs } from "./flowmeters/flomecFlowmeterClusterConfigs.js";
import { genericFlowmeterClusterConfigs } from "./flowmeters/genericFlowmeterClusterConfigs.js";
import { mccrometerFlowmeterClusterConfigs } from "./flowmeters/mccrometerFlowmeterClusterConfigs.js";
import { verdiFlowmeterClusterConfigs } from "./flowmeters/verdiFlowmeterClusterConfigs.js";
import { hydrascoutSdi12ClusterConfigs } from "./hydrascout/hydrascoutSdi12ClusterConfigs.js";
import { batteryClusterConfigs } from "./internal/batteryClusterConfigs.js";
import { genericDiagnosticClusterConfigs } from "./internal/genericDiagnosticClusterConfigs.js";
import { networkStatsClusterConfigs } from "./internal/networkStatsClusterConfigs.js";
import { solenoidClusterConfigs } from "./internal/solenoidClusterConfigs.js";
import { tempHumClusterConfigs } from "./internal/tempHumClusterConfigs.js";
import { pressureTransducerClusterConfigs } from "./pressureTransducers/pressureTransducerClusterConfigs.js";
import { sensoterraClusterConfigs } from "./sensoterra/sensoterraClusterConfigs.js";
import { genericTotalizerClusterConfigs } from "./totalizers/genericTotalizerClusterConfigs.js";
import { SensorClusterConfig } from "./types.js";
import { zoneVirtualClusterConfigs } from "./virtual/zoneVirtualClusterConfigs.js";

export const sensorClusterConfigs: Record<string, SensorClusterConfig<any>> = {
    // External physical sensors
    ...verdiFlowmeterClusterConfigs,
    ...badgermeterFlowmeterClusterConfigs,
    ...flomecFlowmeterClusterConfigs,
    ...mccrometerFlowmeterClusterConfigs,
    ...genericFlowmeterClusterConfigs,
    ...genericTotalizerClusterConfigs,
    ...pressureTransducerClusterConfigs,
    ...hydrascoutSdi12ClusterConfigs,
    ...ePlantTreeTagClusterConfigs,
    ...sensoterraClusterConfigs,

    // Internal physical sensors
    ...tempHumClusterConfigs,

    // Generic diagnostic sensors (shared across device generations)
    ...genericDiagnosticClusterConfigs,

    // Generation-specific diagnostic sensors
    ...batteryClusterConfigs,
    ...networkStatsClusterConfigs,
    ...solenoidClusterConfigs,

    // Zone virtual sensors
    ...zoneVirtualClusterConfigs,
};
